import * as React from 'react';
import { Container, Header, List } from 'semantic-ui-react';

import './style.css';

export const Instructions: React.SFC = () => (
  <div className="download-instructions">
    <Container>
      <div className="download-instructions__background">
        <Header as="h3" className="download-instructions__title">
          How to download and install the Fluent Forever Beta App
        </Header>
        <div className="download-instructions__block">
          <div className="download-instructions__description">
            Here is a step-by-step guide to downloading the beta app on your smartphone<br />
            (your confirmation email will also link to these instructions).
          </div>
          <br />
          <div className="instructions" >
            For the installation of our Official Beta we will need to use a beta tool called HockeyApp because we are not quite ready to launch in the app stores yet. Since HockeyApp is not the usual way you’re used to downloading an app onto your smartphone, we have made these step-by-step guides to make things easier for you. Follow the instructions below according to your smartphone operating system:
          </div>
          <br />
          <div>
            <b>iOS Official Beta - <a href="https://rink.hockeyapp.net/apps/503bc5a838a94d728efff698b84646ef">Click here to download</a></b>
          </div>
          <ul className="download-instructions__list">
            <li>
              1.  Follow link <b>on your smartphone</b>
            </li>
            <li>
              2. Click <b>Install/Download</b>
            </li>
            <li>
              3. Click <b>Install</b>
            </li>
            <li>
              4. <b>Settings</b> -> <b>General</b> -> <b>Device Management</b> -> <b>Mokriya L.L.C.</b> -> click <b>Trust</b> -> click <b>Trust</b>
            </li>
          </ul>

          <br />
          <div>
            <b>Android Official Beta - <a href="https://rink.hockeyapp.net/apps/a3a659e41c394c8db28db19bc7a0dff8">Click here to download</a></b>
          </div>
          <br />
          <div >
            For Android 8.0 and up
          </div>
          <ul className="download-instructions__list">
            <li>
              1.  Follow link <b>on your smartphone</b>
            </li>
            <li>
              2. Click <b>Install/Download</b>
            </li>
            <li>
              3. <b>Settings</b> -> <b>Allow from this source</b> -> click <b>Install</b>
            </li>
          </ul>
          <List bulleted>
            <List.Item>For older Android, you will need to allow apps to be installed from Unknown Sources other than the Play Store (some versions can do this under Privacy or Settings - varies on device/version).</List.Item>
            <List.Item>If you have gone through the entire manual (including the "untrusted developer" part) but you are still unable to install the beta, contact us at help@fluent-forever.com.</List.Item>
          </List>
        </div>
      </div>
    </Container>
  </div>
);



// WEBPACK FOOTER //
// ./src/components/presentational/views/Download/sections/Instructions/index.tsx